// extracted by mini-css-extract-plugin
export default {"alert-container":"sessions-alert_alert-container__5lIyy","wrapper":"sessions-alert_wrapper__4+2EF"};